/**
 * OSI-797: числовые коды ошибок авторизации из POST /api/Auth (поле response.code).
 * 0 — успех. Значения согласованы с бэкендом (OSI.Core, enum AuthErrorCodes).
 */
export const AUTH_ERROR_CODE = {
  wrongPassword: 1001,
  wrongOtp: 1002,
  tooManyAttempts: 1003
} as const;

/** i18n-ключи ошибок, показываемых алертом над формой ввода пароля */
export const AUTH_ERROR_MESSAGE: Record<number, string> = {
  [AUTH_ERROR_CODE.wrongPassword]: 'auth:login.errors.wrongPassword',
  [AUTH_ERROR_CODE.wrongOtp]: 'auth:login.errors.wrongOtp'
};
